'use strict';

wbApp.factory('accountingBookSvc', ['$resource', '$q', 'repositorySvc', 'notificationSvc', '$translate',
    function ($resource, $q, repositorySvc, notificationSvc, $translate) {
        var AccountingBooks = $resource('/Api/AccountingBooks/:id', {}, {
            'getAll': { method: 'GET', isArray: true, url: '/Api/AccountingBooks/GetAll' },
            'update': { method: 'POST', url: '/Api/AccountingBooks/Update' },
            'insert': { method: 'POST', url: '/Api/AccountingBooks/Insert' },
            'delete': { method: 'POST', url: '/Api/AccountingBooks/Delete' },
            'peekNextSequenceNoRaw': { method: 'GET', isArray: false, url: '/Api/AccountingBooks/PeekNextSequenceNoRaw' },
            'setNextSequenceNoRaw': { method: 'POST', url: '/Api/AccountingBooks/SetNextSequenceNoRaw' },
            'uploadAccountingStamp': { method: 'PUT', url: '/restapi/accounting-books/:id/accounting-stamp' },
            'deleteAccountingStamp': { method: 'DELETE', url: '/restapi/accounting-books/:id/accounting-stamp' },
            'listInstitutions': { method: 'GET', isArray: true, url: '/restapi/banks/institutions' },
            'createBankConnection': { method: 'POST', url: '/restapi/banks/connections' },
            'getConnection': { method: 'GET', url: '/restapi/banks/connections/:id?refresh=true' },
            'deleteConnection': { method: 'DELETE', url: '/restapi/banks/connections/:id' },
            'selectBankAccount': { method: 'POST', url: '/restapi/banks/connections/:id/select-account/:accountId' }
        });

        function uploadAccountingStamp(id, data) {
            return repositorySvc.customPutWithParams(
                'uploadAccountingStamp',
                AccountingBooks,
                { id: id },
                data);
        }

        function deleteAccountingStamp(id) {
            return repositorySvc.customDelete(
                'deleteAccountingStamp',
                AccountingBooks,
                { id: id });
        }

        function peekNextSequenceNoRaw(sequenceType, accountingBookID, year, success) {
            return repositorySvc.customGet('peekNextSequenceNoRaw', AccountingBooks, {
                sequenceType: sequenceType,
                accountingBookID: accountingBookID,
                year: year
            }, success);
        }

        function setNextSequenceNoRaw(sequenceType, accountingBookID, year, sequenceNumber, success, error) {
            function successImpl(data) {
                notificationSvc.notifyInfo($translate.instant('TXT_ALERT_TITLE_CHANGES_SAVED'));
                if (success) {
                    success(data);
                }
            }

            function errorImpl(errorResult) {
                repositorySvc.defaultErrorHandler(errorResult);
                if (error) {
                    error(errorResult);
                }
            }

            return AccountingBooks.setNextSequenceNoRaw({
                sequenceType: sequenceType,
                accountingBookID: accountingBookID,
                year: year,
                sequenceNumber: sequenceNumber
            }, successImpl, errorImpl);
        }

        var accountingBooks;

        function createNew() {
            return {
            };
        }

        function getAllAsync(refresh) {
            if (!accountingBooks || refresh) {
                accountingBooks = repositorySvc.customGet('getAll', AccountingBooks);
            }

            return accountingBooks;
        }

        function getDefaultAsync() {
            var a = getAllAsync();

            var deferred = $q.defer();

            a.$promise.then(function (data) {
                angular.forEach(data, function (value, key) {
                    if (value.isDefault) {
                        deferred.resolve(value);
                        return;
                    }
                })

                deferred.resolve(null);

            }, function (reason) {
                deferred.reject(reason);
            });

            return deferred.promise;
        }

        function get(id) {
            if (accountingBooks) {
                for (var i = 0; i < accountingBooks.length; i++) {
                    var sc = accountingBooks[i];
                    if (sc.id === id) {
                        return sc;
                    }
                }
            }
            return null;
        }

        function insert(data, successCallback, errorCallback) {
            repositorySvc.insert(
                AccountingBooks,               // $resource
                accountingBooks,               // collection
                data,                          // entity
                successCallback,
                errorCallback);
        }

        function update(data, successCallback, errorCallback) {
            repositorySvc.update(
                AccountingBooks,            // $resource
                accountingBooks,            // collection
                data,                       // entity
                successCallback,
                errorCallback);
        }

        function remove(data, successCallback, errorCallback) {
            repositorySvc.remove(
                AccountingBooks,              // $resource
                accountingBooks,              // collection
                data,                         // entity
                successCallback,
                errorCallback);
        }
        
        function getInstitutions() {
            return repositorySvc.customGet('listInstitutions', AccountingBooks);
        }
        
        function createBankConnection(institutionId, redirectToUrl, accountingBookId) {
            return repositorySvc.customPost(
                'createBankConnection', 
                AccountingBooks, {
                    institutionId: institutionId,
                    redirectToUrl: redirectToUrl,
                    accountingBookId: accountingBookId
                },
                null,
                null,
                true);
        }
        
        function selectBankAccount(connectionId, accountId) {
            return repositorySvc.customPostWithParams(
                'selectBankAccount',
                AccountingBooks, {
                    id: connectionId,
                    accountId: accountId
                },
                null,
                null,
                null);
        }
        
        function getConnection(connectionId) {
            return repositorySvc.customGet('getConnection', AccountingBooks, { id: connectionId });
        }
        
        function deleteConnection(connectionId) {
            return repositorySvc.customDelete('deleteConnection', AccountingBooks, {id: connectionId});
        }

        return {
            createNew: createNew,
            getAllAsync: getAllAsync,
            getDefaultAsync: getDefaultAsync,
            get: get,
            insert: insert,
            update: update,
            remove: remove,
            peekNextSequenceNoRaw: peekNextSequenceNoRaw,
            setNextSequenceNoRaw: setNextSequenceNoRaw,
            uploadAccountingStamp: uploadAccountingStamp,
            deleteAccountingStamp: deleteAccountingStamp,
            getInstitutions: getInstitutions,
            createBankConnection: createBankConnection,
            getConnection: getConnection,
            deleteConnection: deleteConnection,
            selectBankAccount: selectBankAccount
        }
    }]);